export var UploadFileError;
(function (UploadFileError) {
    UploadFileError["UNEXPECTED_ERROR"] = "UNEXPECTED_ERROR";
    UploadFileError["UNSUPPORTED_MEDIA_TYPE"] = "UNSUPPORTED_MEDIA_TYPE";
    UploadFileError["FILE_ALREADY_EXISTS"] = "FILE_ALREADY_EXISTS";
})(UploadFileError || (UploadFileError = {}));
